import { ImportSquare } from 'iconsax-react';

import CloseSquare from '@shared/assets/icons/shared/close-square';
import { DialogClose, DialogTitle } from '@src/design-system/dialog';
import { cn } from '@src/design-system/helpers';

export function FilterModalHeader({
  onMinimize,
  className,
}: {
  onMinimize: () => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'p-6 font-medium w-full flex text-gray-900 items-center justify-between bg-primary-30 rounded-t-xl shrink-0',
        className
      )}
    >
      <DialogTitle className='text-lg font-semibold leading-none tracking-tight'>
        Filter
      </DialogTitle>

      <div className='flex items-center gap-2'>
        <button
          type='button'
          onClick={onMinimize}
          aria-label='Minimize filters'
          className='opacity-80 transition-opacity hover:opacity-100'
        >
          <ImportSquare size={20} />
        </button>

        <DialogClose className='rounded-sm opacity-70 text-gray-900 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2'>
          <CloseSquare />
          <span className='sr-only'>Close</span>
        </DialogClose>
      </div>
    </div>
  );
}
